import { ECS } from '../state';
import { randomInRange } from '~/helpers/MathUtils';
import { urls } from '@/config/assets';
import { beerConfig } from '@/config/games/beer';
import { randomIntRange } from '~/helpers/MathUtils';

export const Clouds = () => {
  // useEffect(() => {
  //   clearClouds();
  //   addClouds(0);
  // }, []);

  return (
    <>
      <ECS.Entities
        in={clouds}
        children={Cloud}
      />
    </>
  );
};

export const Cloud = (entity) => {
  const textures = useAsset([
    urls.t_cloud0,
    urls.t_cloud1,
    urls.t_cloud2,
    urls.t_cloud3,
    urls.t_cloud4,
  ]);

  const texture = textures[entity.type];

  return (
    <ECS.Entity entity={entity}>
      <ECS.Component name="three">
        <group>
          <group position={[0, entity.size[1] * 0.5, 0]}>
            <mesh scale={[1.2, 1.2, 1.2]}>
              <planeGeometry args={[entity.size[0], entity.size[1]]} />
              <GBufferMaterial transparent>
                <MaterialModuleMap map={texture} />
                <MaterialModuleAlphaTest />
              </GBufferMaterial>
            </mesh>
          </group>
        </group>
      </ECS.Component>
    </ECS.Entity>
  );
};

export const clearClouds = () => {
  ECS.world.remove(clouds);
};

// export const addClouds = (areaIdx) => {
//   const area = beerConfig.areas[areaIdx];

//   let lastX = 0;

//   for (let i = 0; i < area.numClouds; i++) {
//     lastX += randomInRange(CLOUD_GAP_MIN, CLOUD_GAP_MAX);

//     const y = randomInRange(1.75, 9);
//     const z = randomInRange(-20, -5);
//     const type = randomIntRange(0, 4);

//     const scale = randomInRange(1, 2);

//     addCloud(lastX, y, z, 2 * scale, 1 * scale, type);
//   }
// };

export const addCloud = (
  x = 0,
  y = 0,
  z = -5,
  width = 2,
  height = 1,
  type = 0
) => {
  const opts = {
    isCloud: true,
    position: { x, y, z },
    size: [width, height, 1],
    type,
  };

  ECS.world.add(opts);
};
